import { Widget } from '../types';
import { WidgetResults } from '../WidgetResults';

interface InitialStateProps {
  widgets: Widget[];
  onWidgetClick: (widget: Widget) => void;
  shouldShowWidgets: boolean;
}

export const InitialState = ({
  widgets,
  onWidgetClick,
  shouldShowWidgets,
}: InitialStateProps) => {
  return (
    <>
      <div className="text-center p-5">
        <h3 style={{ color: 'var(--bq-text-primary)' }}>
          What would you like to search for?
        </h3>
        <p className="mb-3" style={{ color: 'var(--bq-text-secondary)' }}>
          Select a category and try searching for relevant information
        </p>
        <p
          className="font-italic"
          style={{ color: 'var(--bq-text-secondary)' }}
        >
          Try searching for "quarterly report" or "investment strategy"
        </p>
      </div>
      {shouldShowWidgets && (
        <WidgetResults widgets={widgets} onWidgetClick={onWidgetClick} />
      )}
    </>
  );
};
